import axios from "axios";
import Config from "src/config";

const v2_actionChatInternoContatos = (clienteId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat-internal/${clienteId}/contatos`
    });
};
export default v2_actionChatInternoContatos;
